export default [
  {
    path: 'exam-program-presentations',
    name: 'exam-program-presentations',
    component: () => import('@/views/pages/exam-program-presentation/Manage.vue'),
    meta: {
      pageTitle: 'Imtihon dasturlari va taqdimotlar',
      resource: 'ExamProgramPresentation',
      action: 'read',
    },
  },
]
